import './ProductReviewList.style';

import { PureComponent } from 'react';
import { connect } from 'react-redux';
import ProductReviewRating from 'Component/ProductReviewRating';
import Field from 'Component/Field';
import Html from 'Component/Html';
import CustomPagination from '../CustomPagination';
import { getAllowedFieldsFromProductType } from '../../util/Product/Product';

import { ProductType } from 'Type/ProductList';
import ReactTooltip from "react-tooltip";

const ReviewsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Reviews/Reviews.dispatcher'
);

export const mapStateToProps = state => ({
    product: state.ProductReducer.product,
    customer: state.MyAccountReducer.customer,
    isSignedIn: state.MyAccountReducer.isSignedIn,
    reviewRatings: state.ConfigReducer.reviewRatings,
    customerAdditionalAttributes: state.ConfigReducer.customerAdditionalAttributes
});

export const mapDispatchToProps = dispatch => ({
    getSelectedPageProductReviews: (id, page, details) => ReviewsDispatcher.then(
        ({ default: dispatcher }) => dispatcher.requestReviews(dispatch, id, page, details)
    )
});

export class ProductReviewList extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired,
        // householdSkuList: PropTypes.string // New prop from config
    };

    state={
        currentPage: 1,
        age: null,
        sex: null,
        par: null,
        ten: null
    };

    selectPage = this.selectPage.bind(this);

    // TODO refactor and move getAgeInterval + getLabelFromAttribute to utils (see <ProductFaq />)

    getAgeInterval(age) {
        switch (age) {
        case 0:
            return '16-19';
        case 1:
            return '20-24';
        case 2:
            return '25-29';
        case 3:
            return '30-34';
        case 4:
            return '35-44';
        case 5:
            return '45-54';
        case 6:
            return '+55';
        default:
            return '';
        }
    }

    getLabelFromAttribute(attributeList, value) {
        let attrLabel = '';
        for (const attribute of attributeList) {
            if (value === attribute.value) {
                attrLabel = attribute.label;
            }
        }

        return attrLabel;
    }

    getFormattedDate(created_at) {
        // Safari bug
        const fixedDate = created_at.replace(/-/g, '/');
        const date = new Date(fixedDate);
        // Mon Mar 02 2020
        // TODO use this https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
        return date ? date : created_at;
    }

    renderReviewListItemRating = (ratingVoteItem) => {
        const {
            vote_id,
            rating_code,
            percent
        } = ratingVoteItem;

        return (
            <div
              key={ vote_id }
              block="ProductReviewList"
              elem="RatingSummaryItem"
            >

                <ProductReviewRating
                  summary={ percent }
                  code={ rating_code }
                />
            </div>
        );
    };


    renderReviewListItem = (reviewItem) => {
        const {
            detail,
            review_id,
            rating_votes
        } = reviewItem;

        return (
            <li
              key={ review_id }
              block="ProductReviewList"
              elem="Item"
              itemType="http://schema.org/Review"
              itemProp="review"
              itemScope
            >

                <div block="ProductReviewList" elem="RatingAuthor">
                    { this.renderAuthor(reviewItem) }
                </div>
                <div block="ProductReviewList" elem="RatingSummary">
                { rating_votes.map(this.renderReviewListItemRating) }
                </div>
                <div block="ProductReviewList" elem="ReviewContent">
                    <p block="ProductReviewList" elem="ReviewDetails" itemProp="reviewBody">
                        <Html content = { detail } />
                    </p>
                </div>
            </li>
        );
    };

    selectPage(id, page) {
        const { getSelectedPageProductReviews } = this.props;
        this.setState({ currentPage: page }, () => {
            const { age, par, ten, sex, currentPage } = this.state;
            const details = {
                age,
                sex,
                tip_ten: ten,
                tip_par: par
            };
            getSelectedPageProductReviews(id, currentPage, details);
        });
    }

    renderPagination(id, totalPages) {
        const { currentPage } = this.state;

        if (totalPages === 1) return null;

        return (
            <CustomPagination
              isLoading={ false }
              totalPages={ totalPages }
              currentPage={ currentPage }
              onPageSelect={ page => this.selectPage(id, page) }
            />
        );
    }

    renderAuthor(reviewItem) {
        const { customerAttributes } = this.props;
        const {
            nickname,
            created_at,
            age,
            sex,
            tip_par,
            tip_ten,
            verified_sale
        } = reviewItem;
        const review_created_at = this.getFormattedDate(created_at);
        const months = [
            __("january"),
            __("february"),
            __("march"),
            __("april"),
            __("may"),
            __("june"),
            __("july"),
            __("august"),
            __("september"),
            __("october"),
            __("november"),
            __("december")
        ];
        const monthIndex = review_created_at.getMonth();
        const monthName = months[monthIndex];

        const verifiedCheckSvg = (<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
        </svg>);

        return (
            <div block="ProductReviewList" elem="ReviewAuthor" itemProp="author" itemType="http://schema.org/Person" itemScope>
                <meta itemProp="name" content={ nickname } />
                <strong>{ nickname }</strong>
                <div>
                    { (age || age === 0) && <span>{ __('Age: %s', this.getAgeInterval(age)) }</span> }
                    { sex && customerAttributes && customerAttributes.sex && <span>{ __('Sex: %s', this.getLabelFromAttribute(customerAttributes.sex.attribute_options, sex))}</span> }
                    { tip_par && customerAttributes && customerAttributes.tip_par && <span>{ __('Hair type: %s', this.getLabelFromAttribute(customerAttributes.tip_par.attribute_options, tip_par)) }</span> }
                    { tip_ten && customerAttributes && customerAttributes.tip_ten && <span>{ __('Skin type: %s', this.getLabelFromAttribute(customerAttributes.tip_ten.attribute_options, tip_ten)) }</span> }
                    <span>{ __('%s', `${review_created_at.getDate()} ${monthName} ${review_created_at.getFullYear()}`) }</span>
                    <div data-tip={verified_sale ? __('Review verified description') : __('Review not verified description')}>
                        <span >{ verified_sale ? __('Review verified sale') : __('Review not verified')}</span>
                        { verified_sale && verifiedCheckSvg }
                    </div>
                    <ReactTooltip place='bottom' clickable='true' effect='solid' multiline='true' className='review-tooltip' type='light' />

               </div>
            </div>
        );
    }

    renderReviews() {
        const { product: { reviews } } = this.props;
        return reviews.map(this.renderReviewListItem);
    }

    setFilterAttribute(id, stateObj) {
        const { getSelectedPageProductReviews } = this.props;

        this.setState({ currentPage: 1, ...stateObj }, () => {
            const { age, par, ten, sex, currentPage } = this.state;

            const details = {
                age: age || null,
                sex: sex,
                tip_ten: ten,
                tip_par: par
            };

            getSelectedPageProductReviews(id, currentPage, details);
        });
    }

    renderReviewsFilters() {
        const {
            product: {
                sku,
                review_summary,
                attributes: {
                    tip_produs
                }
            },
            householdSkuList,
            customerAdditionalAttributes
        } = this.props;

        if (householdSkuList) {
            const skuArray = householdSkuList.split(',').map(code => code.trim());
            if (skuArray.includes(sku)) {
                return null;
            }
        }

        const requiredFields = getAllowedFieldsFromProductType(tip_produs);

        let { customer } = this.props;

        if (!customer) {
            customer = {};
        }

        const { age, par, ten, sex } = this.state;

        if (!review_summary.review_count) {
            return null;
        }

        return (
            <div block="ProductReviewList" elem="Filters">
                <div block="ProductReviewList" elem="Count">{ __('%s reviews', review_summary.review_count || 0) }</div>

                { tip_produs.attribute_value && ( <div block="ProductReviewList" elem="FiltersContainer">
                    <strong>{__('Filter by')}:</strong>
                    <div>
                        { requiredFields.tip_ten && (
                            <Field
                                type="select"
                                label={ __('Skin type') }
                                id="skin_type"
                                name="skin_type"
                                placeholder={ __('Skin type') }
                                validation={ ['notEmpty'] }
                                selectOptions={ customerAdditionalAttributes?.tip_ten?.attribute_options }
                                value={ ten || '' }
                                onChange={ e => this.setFilterAttribute(sku, { ten: e }) }
                            />
                        ) }
                        { requiredFields.tip_par && (
                            <Field
                                type="select"
                                label={ __('Hair type') }
                                id="hair_type"
                                name="hair_type"
                                placeholder={ __('Hair type') }
                                validation={ ['notEmpty'] }
                                selectOptions={ customerAdditionalAttributes?.tip_par?.attribute_options }
                                value={ par || '' }
                                onChange={ e => this.setFilterAttribute(sku, { par: e }) }
                            />
                        ) }
                        { requiredFields.age && (
                            <Field
                                type="select"
                                id="age"
                                name="age"
                                label={ __('Age') }
                                placeholder={ __('Age') }
                                selectOptions={ [
                                    { label: '16-19', value: 0 },
                                    { label: '20-24', value: 1 },
                                    { label: '25-29', value: 2 },
                                    { label: '30-34', value: 3 },
                                    { label: '35-44', value: 4 },
                                    { label: '45-54', value: 5 },
                                    { label: '55+', value: 6 }
                                ] }
                                validation={ ['notEmpty'] }
                                value={ age || '' }
                                onChange={ e => this.setFilterAttribute(sku, { age: e }) }
                            />
                        ) }
                        { requiredFields.sex && (
                            <Field
                                type="select"
                                id="gender"
                                name="gender"
                                label={ __('Gender') }
                                placeholder={ __('Gender') }
                                selectOptions={ customerAdditionalAttributes?.sex?.attribute_options }
                                validation={ ['notEmpty'] }
                                value={ sex || '' }
                                onChange={ e => this.setFilterAttribute(sku, { sex: e }) }
                            />
                        ) }
                        <button onClick={ () => this.resetFilters(sku) }>{ __("Reset filters") }</button>
                    </div>
                </div> )}
            </div>
        );
    }

    resetFilters(sku) {
        const { getSelectedPageProductReviews } = this.props;

        this.setState({ currentPage: 1, age: null, sex: null, par: null, ten: null }, () => {
            const { age, par, ten, sex, currentPage } = this.state;
            const details = {
                age,
                sex: sex,
                tip_ten: ten,
                tip_par: par
            };

            getSelectedPageProductReviews(sku, currentPage, details);
        });
    }

    getCustomerInterval(dob) {
        const diff_ms = Date.now() - new Date(dob).getTime();
        const age_dt = new Date(diff_ms);
        const age = Math.abs(age_dt.getUTCFullYear() - 1970);
        if (age > 55) {
            return 6;
        } if (age > 45) {
            return 5;
        } else if (age > 35) {
            return 4;
        } else if (age > 30) {
            return 3;
        } else if (age > 25) {
            return 2;
        } else if (age > 20) {
            return 1;
        }

        return 0;
    }

    render() {
        const { product } = this.props;

        return (
            <div block="ProductReviewList">
                { this.renderReviewsFilters() }
                <ul block="ProductReviewList" elem="Container">
                    { this.renderReviews() }
                </ul>
                { this.renderPagination(product.sku, product.reviewsTotalPages) }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewList);
